import * as React from 'react';
import {
  usePageSpeedIconWithAction,
  useSpeedDealMenuOpened,
} from '@dpdgroupuk/fmx-ui/components/Page/hooks';
import { isMobile } from '@dpdgroupuk/fmx-ui/utils/helpers';

import { Chat } from '../../components/Icons';

const createChatIconWithAction = ({
  setShowChat,
  showChat,
  showChatIcon,
  loadChat,
  setLoadChat,
  loadFn,
}) => {
  const action = async () => {
    if (!loadChat) {
      try {
        await loadFn();
        setLoadChat(true);
        setShowChat(true);
      } catch (error) {
        // Load failed: keep chat closed and exit early
        setLoadChat(false);
        setShowChat(false);
      }
    } else {
      setShowChat(!showChat);
    }
  };
  return showChatIcon ? [Chat, action] : [];
};

export const useChatIconWithAction = ({
  setShowChat,
  showChat,
  setLoadChat,
  loadChat,
  showChatIcon,
  chatOrigin,
  loadFn,
}) => {
  const iconWithAction = React.useMemo(
    () =>
      createChatIconWithAction({
        setShowChat,
        showChat,
        loadChat,
        setLoadChat,
        showChatIcon,
        loadFn,
      }),
    [setShowChat, showChat, loadChat, setLoadChat, showChatIcon, loadFn]
  );
  usePageSpeedIconWithAction(iconWithAction);
  useSpeedDealMenuOpened(showChat ? false : isMobile ? chatOrigin : true);
};

export const useDelay = chatbotButtonDelay => {
  const [delay, setDelay] = React.useState(false);
  const isMounted = React.useRef(false);
  const time = parseInt(chatbotButtonDelay);

  React.useEffect(() => {
    isMounted.current = true;

    setTimeout(() => {
      if (isMounted.current) {
        setDelay(true);
      }
    }, time);

    return () => {
      isMounted.current = false;
    };
  }, [time]);

  return delay;
};
